import JsBarcode from 'jsbarcode';
import React, { useEffect, useRef } from 'react';
import './barcode-display.scss';

interface BarcodeDisplayProps {
    value: string;
    width?: number;
    height?: number;
    displayValue?: boolean;
    fontSize?: number;
    format?: string;
    background?: string;
    lineColor?: string;
    margin?: number;
    className?: string;
}

const BarcodeDisplay: React.FC<BarcodeDisplayProps> = ({
    value,
    width = 2,
    height = 80,
    displayValue = true,
    fontSize = 18,
    format = 'CODE128',
    background = '#ffffff',
    lineColor = '#000000',
    margin = 10,
    className = ''
}) => {
    const svgRef = useRef<SVGSVGElement>(null);
    const [error, setError] = React.useState<string>('');

    useEffect(() => {
        if (svgRef.current && value) {
            try {
                JsBarcode(svgRef.current, value, {
                    format,
                    width,
                    height,
                    displayValue,
                    fontSize,
                    background,
                    lineColor,
                    margin
                });
                setError('');
            } catch (err) {
                console.error('Error generating barcode:', err);
                setError('Invalid barcode value');
            }
        }
    }, [value, width, height, displayValue, fontSize, format, background, lineColor, margin]);

    if (!value) {
        return (
            <div className={`barcode-display-empty ${className}`}>
                <p>No barcode value provided</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`barcode-display-error ${className}`}>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className={`barcode-display-container ${className}`}>
            <svg ref={svgRef} />
        </div>
    );
};

export default BarcodeDisplay;

